import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Information from './components/Information';
import InformationError from './components/InformationError';

import { getCopyFinalMarksModalData } from '../../../../redux/appConfig/selectors';

/**
 * Komponent rozdzielający czy dodatkowe informacje mają się pojawić i jeśli tak to jakie
 */
const AdditionalInformation = (): JSX.Element | null => {
  const ref = useRef<number[]>([]);
  const {
    error,
    studentData,
    selected,
    studentsWithManuallySignedFinalMark,
    studentsWithoutOcenaWyliczona,
    studentsWithMarksByAnotherCounter,
  } = useSelector(getCopyFinalMarksModalData);

  useEffect(() => {
    ref.current.push(studentData.length);
  }, [studentData]);

  return error.isError && error.hash ? (
    <InformationError studentLength={studentData.length} prevStudentLength={Math.max(...ref.current)} hash={error.hash} />
  ) : selected !== studentData.length || studentsWithMarksByAnotherCounter > 0 ? (
    <Information
      studentsWithoutCalculatedMark={studentsWithoutOcenaWyliczona}
      studentsWithManuallySignedFinalMark={studentsWithManuallySignedFinalMark}
      studentsWithMarksByAnotherCounter={studentsWithMarksByAnotherCounter}
    />
  ) : null;
};

export default AdditionalInformation;
